//省级
export const errorCode = {
    "1001": "更换其他身份信息下单",
    "1002": "更换其他身份信息下单",
    "1003": "更换其他身份信息下单",
    "1004": "更换收货号码",
    "1006": "删除在途单或者换身份信息或者30天后发货",
    "1005": "检查收货地址或者更换地址",
    "default": "请检查身份信息是否正确！"
}

function getSolution(code) {
    if(errorCode[code]){
        return errorCode[code];
    } else{
        return errorCode['default'];
    }
}
export default { getSolution }